import Link from 'next/link';
import { useEffect } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Category } from '@/api/games';
import { GamesGrid } from '@/components/GamesGrid';
import type { ISearchFallbackScenariosProps } from '..';

import { ScSearchFallbackScenario } from '../styled';

type PennyScenarioProps = ISearchFallbackScenariosProps;

export const PennyScenario: React.FC<PennyScenarioProps> = ({
  gridOptions,
  handleSearchGameClick,
  sendSearchResultAppearance,
  closeModal,
}) => {
  const { t } = useTranslation('lobby');

  useEffect(() => {
    sendSearchResultAppearance({ status: 'custom' });
  }, []);

  return (
    <ScSearchFallbackScenario>
      <div className="text">
        <p>{t('searchFallback.title')}</p>
        <p>
          <Trans
            components={{
              l: (
                <Link
                  className="link"
                  href="/games/wagering/sub-category/penny_bets#gamesSection"
                  onClick={closeModal}
                />
              ),
            }}
            i18nKey="searchFallback.subtitle.penny"
            ns="lobby"
          />
        </p>
      </div>
      <GamesGrid
        category={Category.PENNY_BETS}
        {...gridOptions}
        onDemoClick={(game) => handleSearchGameClick(game, 'custom_penny')}
        onPlayClick={(game) => handleSearchGameClick(game, 'custom_penny')}
      />
    </ScSearchFallbackScenario>
  );
};
